import script from "./FrontPageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FrontPageView.vue?vue&type=script&setup=true&lang=ts"

import "./FrontPageView.vue?vue&type=style&index=0&id=e417dff8&lang=css"

const __exports__ = script;

export default __exports__